import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Loader from "./components/Loader";
import Cart from "./pages/Cart";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Dashboard from "./pages/dashboard/users/UserDashboard";
import AdminDashboard from "./pages/dashboard/admin/AdminDashboard";
import AdminUsers from "./pages/dashboard/admin/AdminUsers";
import SignupSuccess from "./pages/signup-success";
import { useAppDispatch } from "./redux/hooks";
import { client } from "./appWrite";
import PaymentPage from "./pages/Payment";
import AboutUs from "./pages/AboutUs";
import Products from "./pages/Products";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AuthPage from "./pages/AuthPage";
import { fetchPosts } from "./redux/slices/AllPostSlice";
import { fetchFAQs } from "./redux/slices/FaqSlice";
import { fetchTestimonials } from "./redux/slices/TestimonialSlice";
import RequestReset from "./pages/RequestResetPw";
import ResetPassword from "./pages/ResetPassword";
import { fetchItems } from "./redux/slices/AllItemSlice";
import FloatingButton from "./components/FloatingButton";

function App() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useAppDispatch();

  // Preloader timeout
  useEffect(() => {
    dispatch(fetchPosts());
    dispatch(fetchItems());
    dispatch(fetchFAQs());
    dispatch(fetchTestimonials());
    console.log(client);

    setTimeout(() => {
      setIsLoading(false);
    }, 1200);
  }, [dispatch]);

  return (
    <div className="App">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/products" element={<Products />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/blog-post" element={<BlogPost />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/payment/:price" element={<PaymentPage />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/signup-success" element={<SignupSuccess />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/password-request" element={<RequestReset />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/admin-users" element={<AdminUsers />} />
          </Routes>
          <FloatingButton
            phoneNumber="+2348033607144"
            message="Hello Rehoboth!, I'd like to make an inquiry!"
          />
        </>
      )}
    </div>
  );
}

export default App;
